


import {CalendarSlotStatus} from './CalendarSlotStatus'; 
export class CalendarSlotVM {
    
    status?: CalendarSlotStatus;
    
    start?: Date;
    
    end?: Date;
    
}
